export default "__VITE_ASSET__CCaSznPp__"